/**
 * Action types for topology functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle topology action.
 */

export const IS_SIDE_BAR_TOPOLOGY_OPEN = 'IS_SIDE_BAR_TOPOLOGY_OPEN';
export const SIDE_BAR_TOPOLOGY_FLOATING = 'SIDE_BAR_TOPOLOGY_FLOATING';
export const SELECTED_NODE_TOPOLOGY = 'SELECTED_NODE_TOPOLOGY';
export const UPDATE_DELETE_MODAL = 'UPDATE_DELETE_MODAL'
export const UPDATE_IMPORT_MODAL = 'UPDATE_IMPORT_MODAL'
export const SHOW_EXPORT_ALERT = 'SHOW_EXPORT_ALERT'
export const SHOW_GROUP_DOWNLOAD_SUCCESS_ALERT = 'SHOW_GROUP_DOWNLOAD_SUCCESS_ALERT'
export const GROUP_DOWNLOAD = 'GROUP_DOWNLOAD'
export const SHOW_GROUP_CLONE_MODAL = 'SHOW_GROUP_CLONE_MODAL'
export const SHOW_GROUP_CONFIGURE_MODAL = 'SHOW_GROUP_CONFIGURE_MODAL';
export const SELECTED_SWITCH_TAB = 'SELECTED_SWITCH_TAB';
export const SELECTED_GROUP_NAME = 'SELECTED_GROUP_NAME';
export const SHOW_IMPORT_ALERT = 'SHOW_IMPORT_ALERT';
export const UPDATE_SIDEBAR_WIDTH = 'UPDATE_SIDEBAR_WIDTH';
